<template>
  <NavBar/>
      <section :class="[{'min-vh-100': projects.length},'features pt-5']" id="features">
          <div class="heading text-center pt-5">
              <h2 class="hdr pb-3"> {{ type }} Projects</h2>
          </div>
          <div v-if="!projects.length" class="row mx-auto justify-content-center align-items-center text-center pb-5">
              <h2 class="mt-5">Coming Soon</h2>
          </div>
          <div v-else class="row mx-auto justify-content-center align-items-center text-center pb-5">
              <div v-for="project in projects" :key="project.name" 
                  :class="[[type],'card project col-md-3 m-3 pt-3']">
                  <img :src="project.img" class="card-img-top" alt="...">
                  <div class="card-body px-0 pb-0">
                      <h4 class="card-title">{{ project.name }}</h4>
                      <p>{{ project.detail }}</p>
                  </div>
                  <a :href="project.link" class="btn btn-success mb-3">Download</a>
              </div>
          </div>
      </section>
    <Footer :class="!projects.length ? 'fixed-bottom' : ''"/>
</template>

<script>
import { ref } from '@vue/reactivity'
import { useRoute,useRouter } from 'vue-router';
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'

export default {
    components: {
        NavBar,
        Footer
    },
    setup(){
        const route = useRoute();
        const router = useRouter();
        document.title = 'Soncraft | '+route.params.id.charAt(0).toUpperCase() + route.params.id.slice(1)+' Projects'
        
        const type = ref(route.params.id)
        const projects = ref([])

        const java = ref([
            {name: 'JavaFX - Paint App', 
                img: require('@/assets/projects/thumb-paint.png'),
                link: 'http://download1496.mediafire.com/0zjn4sdg78pg/nvljl636j0yhp7r/SimplePaintApp.zip', 
                detail: 'Simple paint windows application with basic tools like pencil, brush, eraser and shapes.'},
            {name: 'JavaFX - Music Player',
                img: require('@/assets/projects/thumb-music-player.png'),
                link: 'http://download1638.mediafire.com/ctcdlcgkygfg/lbswdu3xvcehqqb/MusicPlayer.zip',
                detail: 'Play some musics with this simple mp3 player with JavaFX.'},
            {name: 'E-Voting System',
                img: require('@/assets/projects/thumb-evs.png'),
                link: 'https://drive.google.com/file/d/120gkokojvk4DzsM05G89ePlRG-ZwHubb/view?usp=sharing',
                detail: 'Electronic Voting System made using Java.'}
        ])
        const csharp = ref([])
        const python = ref([])
        const android = ref([])
        const arduino = ref([])
        const unity = ref([])
        const godot = ref([])
        const blender = ref([
            {name: 'Mug', 
                img: require('@/assets/projects/thumb-mug.png'),
                link: 'https://download942.mediafire.com/ii3co1ms8wzg/7xawhtjqps545p2/Mug.zip',
                detail: ''},
            {name: 'Miku', 
                img: require('@/assets/projects/thumb-miku.png'),
                link: 'https://download1979.mediafire.com/vv0zwma80bhg/1i6fyn9qqwdhw5c/Miku+Nakano.zip',
                detail: ''},
            {name: 'Mech', 
                img: require('@/assets/projects/thumb-mech.png'),
                link: 'https://download1653.mediafire.com/egzze0ilfvfg/r9hrc9ddroz8frg/Mech.zip',
                detail: ''}
        ])

        switch (route.params.id) {
          case "java":
            projects.value = java.value
            break;
          case "c#":
            projects.value = csharp.value
            break;
          case "python":
            projects.value = python.value
          break;
            case "android":
            projects.value = android.value
          break;
            case "arduino":
            projects.value = arduino.value
          break;
            case "unity":
            projects.value = unity.value
          break;
            case "godot":
            projects.value = godot.value
            break;
          case "blender":
            projects.value = blender.value
            break;
          default:
            router.push({name: 'NotFound', params: { catchAll: route.params.id }}); 
        }

        return{
            projects,
            java, csharp, python,android,
            arduino, unity, godot, blender, 
            type
        }
    }
}
</script>

<style>
section .hdr{
    text-transform: capitalize;
}

@media screen and (max-width: 900px){
  .hero h2{
      font-size: 350%;
  }
  .hero p{
      font-size: 1rem;
      padding-left: 10%;
      padding-right: 10%;
  }
  .features .heading h2{
      font-size: 175%;
  }
  .features .row{
      font-size: 100%;
  }
  .features .project{
      width: 20rem;
  }
  .features .blender{
      height: 26rem;
  }
  .features .java{
      height: 22rem;
  }
}
</style>